import AsyncStorage from '@react-native-async-storage/async-storage';

import { clampAnnualRatePct } from '../../utils/investmentCompounding';

const KEY = '@budget/assumed_return_pct';
/** Previous Wealth-only key — migrated on first read. */
const LEGACY_KEY = '@budget/investments_vs_debt_return_pct';

/** Device cache of the assumed annual return (server is source of truth after login). */
export async function loadAssumedReturnPct(): Promise<number | null> {
  try {
    const raw = (await AsyncStorage.getItem(KEY)) ?? (await AsyncStorage.getItem(LEGACY_KEY));
    if (raw == null) return null;
    const value = Number.parseFloat(raw);
    if (!Number.isFinite(value)) return null;
    return clampAnnualRatePct(value);
  } catch {
    return null;
  }
}

export async function saveAssumedReturnPct(value: number): Promise<void> {
  try {
    const next = String(clampAnnualRatePct(value));
    await AsyncStorage.setItem(KEY, next);
    await AsyncStorage.removeItem(LEGACY_KEY);
  } catch {
    // non-fatal
  }
}

export async function clearAssumedReturnPct(): Promise<void> {
  try {
    await AsyncStorage.multiRemove([KEY, LEGACY_KEY]);
  } catch {
    // non-fatal
  }
}
